<app-layout class="container--md">
    <div>
        <div class="unauthorized__content-container">
            <div class="unauthorized__left">
                <img src="/assets/images/Restricted Permission.svg" alt="unauthorized person">
            </div>
            <div class="unauthorized__right">
                <h1>Restricted Access</h1>
                <p>You do not have access to view this page. Please check that the URL is correct and your account has
                    access.</p>
            </div>
        </div>
    </div>
</app-layout>